import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { VNode } from 'vue'

import { widgetList } from '../utils/consts'

export interface Pair {
  label: string
  value: string
}

@Component
export default class CreateForm extends Vue {
  @Ref() readonly dForm
  public schema: any = {}
  public visible = false
  public pair: Pair = { label: '', value: '' }
  public pairs: Pair[] = []
  public isSelect = false

  created() {
    this.schema = {
      properties: {
        code: {
          title: this.$t('page_resource_pool_field'),
          description: this.$t('page_resource_pool_code_reg')
        },
        title: {
          title: this.$t('page_resource_pool_display_name')
        },
        widget: {
          title: this.$t('widget'),
          default: 'INPUT',
          ui: {
            widget: 'select',
            showSearch:true
          },
          enum: widgetList(this)
        },
        isEnabled: {
          title: this.$t('page_resource_pool_show'),
          default: true,
          ui: {
            widget: 'switch'
          }
        },
        isRequired: {
          title: this.$t('page_resource_pool_required'),
          default: true,
          ui: {
            widget: 'switch'
          }
        },
        sort: {
          title: this.$t('page_resource_pool_sort'),
          default: 0,
          ui: {
            widget: 'input-number'
          }
        }
      },
      required: ['code', 'title', 'widget']
    }
  }

  handleCreate() {
    const isExist = !!this.pairs.find(item => item.label === this.pair.label || item.value === this.pair.value)
    if (isExist) {
      this.$message.info(this.$t('page_resource_pool_repeat_add'))
    } else {
      this.pairs = [...this.pairs, this.pair]
      this.visible = false
      this.pair = { label: '', value: '' }
    }
  }

  handleDelete(index) {
    this.pairs.splice(index, 1)
  }

  onSelectChange(e) {
    this.isSelect = e === 'SELECT'
  }

  render(): VNode {
    return (
      <div>
        <d-form schema={this.schema} ref="dForm" onSelectChange={this.onSelectChange} />
        {this.isSelect ? <a-button onClick={() => (this.visible = true)}>{this.$t('page_resource_pool_add_option')}</a-button> : null}
        {this.pairs.map((pair, index) => (
          <div>
            label: {pair.label} - value: {pair.value}
            <a-icon type="delete" style="color: #F56C6C; padding-left: 16px;" onClick={() => this.handleDelete(index)} />
          </div>
        ))}
        <a-modal
          title={this.$t('page_resource_pool_create')}
          v-model={this.visible}
          onOk={this.handleCreate}
          okText={this.$t('submit')}
          cancelText={this.$t('cancel')}
          destroyOnClose={true}
          maskClosable={false}
        >
          <a-form-item label="label">
            <a-input v-model={this.pair.label} placeholder="请输入label"/>
          </a-form-item>
          <a-form-item label="value">
            <a-input v-model={this.pair.value} placeholder="请输入value"/>
          </a-form-item>
        </a-modal>
      </div>
    )
  }
}
